<template>
  <div id="face-similarity">
    <center><h2>Face Similarity</h2></center>
    <div v-if="loading">Loading...</div>
    <div v-for="face of faces" :key="face.runtime_face_uuid" class="row">
      <div class="image-area">
        <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + face.runtime_face_uuid" height='160dp'/>
        <!-- <img :src="BASE_URL + '/api/v4/faceimage/' + match.runtime_face_uuid" height='160dp'/> -->
      </div>
      <div class="results-area">
        <img :src="imageUriForFrontendFaceUUID(face.frontend_face_uuid)" />
        <div id="ssim-area">
          SSIM: {{face.ssim.toFixed(4)}}
        </div>
        <div class="name-area">
          <div id="circle" v-bind:style="{background: colorForMatchConfidence(face.match_confidence)}" />&nbsp;{{confidenceformat(face.match_confidence)}}&nbsp;
          <router-link v-bind:to="'/faces/' + personNameForUUID(face.frontend_face_uuid)" class="potential-match-name">{{personNameForUUID(face.frontend_face_uuid)}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {facesssim} from '../api/faces';
import {confidenceformat, colorForMatchConfidence} from '../util/confidence';

export default {
  name: 'face-images',
  data: function() {
    return {
      faces: [],
      loading: false,
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateResults()
  },
  methods: {
    confidenceformat, colorForMatchConfidence,
    updateResults() {
      this.loading = true
      facesssim().then(res => res.data).then(data => {
        this.loading = false;
        if (!data.ok) {
          return console.error(data.err);
        }
        this.faces = data.faces;
      })
    },
    imageUriForFrontendFaceUUID(frontend_face_uuid) {
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      if (!face.images || !face.images.length) {
        console.log(`frontend face has no images: ${frontend_face_uuid}`);
        return '';
      }
      return face.images[0].thumbnail_uri;
    },
    personNameForUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      return face.person_name;
    },
  }
}
</script>

<style scoped>

.row {
  display: flex;
  flex-direction: row;
}

.name-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

#circle {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: red;
  margin-right: 10px;
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// FaceSimilarity.vue?14b6efbf